<div class="mat-elevation-z5">
  <mat-toolbar color="primary">
    <mat-icon svgIcon="email"></mat-icon>
    <h1 class="mat-title">{{title}}</h1>
  </mat-toolbar>
  <form [formGroup]="emailForm" (submit)="onSend()" class="mat-body">
    <mat-form-field>
      <mat-label>Aan</mat-label>
      <input matInput type="email" formControlName="bcc"/>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Onderwerp</mat-label>
      <input matInput type="text" formControlName="subject"/>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Bericht</mat-label>
      <textarea matInput formControlName="body" rows="10" placeholder="Email bericht"></textarea>
    </mat-form-field>
    <div class="uf-action-row">
      <button mat-button mat-raised-button type="button" (click)="onClose()">Annuleren</button>
      <button mat-button mat-raised-button color="primary" type="submit" [disabled]="!emailForm.dirty || !emailForm.valid">Verzenden</button>
    </div>
  </form>
</div>
